import { CommercialClientTermResponse } from '@interfaces/partners/responses/commercial-client-term.response';

/**
 * Estado do Consentimento SCR do deal (card 3380), lido pelo `app-deal-consent-card` (card 3418).
 *
 * - `signed`: o termo NDA + carta de SCR fechou; as consultas restritivas (SCR) estão liberadas a
 *   partir da data da última assinatura.
 * - `waiting`: o termo foi enviado e ainda falta assinatura do cliente.
 * - `notSent`: o termo existe, mas ainda não foi enviado ao cliente.
 */
export interface ConsentNotice {
  tone: 'signed' | 'waiting' | 'notSent';
  /** Data da assinatura (ISO); só no `signed`. */
  signedAt: string | null;
}

/**
 * O aviso de consentimento, ou `null` quando não há o que dizer: sem termo (ainda não solicitado) ou
 * termo cancelado. É a regra "só quando há informação coletada" do card.
 */
export function consentNotice(
  term: CommercialClientTermResponse | null | undefined
): ConsentNotice | null {
  if (!term) return null;

  switch (term.status) {
    case 'Assinado':
      return term.signedAt ? { tone: 'signed', signedAt: term.signedAt } : null;
    case 'Enviado':
    case 'AssinadoParcialmente':
      return { tone: 'waiting', signedAt: null };
    case 'Pendente':
      return { tone: 'notSent', signedAt: null };
    default:
      return null;
  }
}
